import { pick } from 'ramda';
import { useMemo } from 'react';
import { useAppSelector } from 'js/store/hooks';

export const useAppPublicAPI = () => {
    const {
        rootPage,
        casinoName,
        clientSkin,
        clientType,
        clientVersion,
        defaultLocale,
        defaultCountry,
        defaultCurrency,
        galaxyClientType,
        galaxyClientVersion
    } =
        useAppSelector(pick([
            'rootPage',
            'casinoName',
            'clientSkin',
            'clientType',
            'clientVersion',
            'defaultLocale',
            'defaultCountry',
            'defaultCurrency',
            'galaxyClientType',
            'galaxyClientVersion'
        ]));

    return useMemo(() => ({
        /**
         * Gets the app configuration.
         * @memberOf Playtech.API.app
         * @function getAppConfiguration
         * @returns {{
         *  rootPage: string,
         *  casinoName: string,
         *  clientSkin: string,
         *  clientType: string,
         *  clientVersion: string,
         *  defaultLocale: string,
         *  defaultCountry: string,
         *  defaultCurrency: string,
         *  galaxyClientType: string,
         *  galaxyClientVersion: string
         * }}
         * @example
         * Playtech.API.app.getAppConfiguration();
         */
        getAppConfiguration: () => ({
            rootPage,
            casinoName,
            clientSkin,
            clientType,
            clientVersion,
            defaultLocale,
            defaultCountry,
            defaultCurrency,
            galaxyClientType,
            galaxyClientVersion
        })
    }), [
        rootPage, casinoName, clientSkin, clientType, clientVersion, defaultCountry,
        defaultCurrency, defaultLocale, galaxyClientType, galaxyClientVersion
    ]);
};
